"use client"

import React from "react"
import { Icon24 } from "../../button/Icon"
import { useBottomSheetStore } from "../store/useBottomSheetStore"

export type BottomSheetMenuItemProps =
  | {
      id?: string
      title: string
      icon?: string
      iconColor?: string
      keepOpen?: boolean
      onClick: () => void
    }
  | {
      component: React.ReactNode
    }

const BottomSheetMenuItem = (
  props: BottomSheetMenuItemProps & { className?: string },
) => {
  const { closeSheet } = useBottomSheetStore()
  const { className } = props

  // React 컴포넌트인 경우
  if ("component" in props) {
    return (
      <>
        <li className={`${className ? className : ""} h-[68px]`}>
          {props.component}
        </li>
      </>
    )
  }

  // 기존 메뉴 아이템인 경우
  const { id, title, icon, iconColor, keepOpen, onClick } = props
  return (
    <>
      <li className={`${className ? className : ""} h-[68px]`}>
        <button
          id={id}
          className="w-full"
          onClick={() => {
            if (!keepOpen) closeSheet()
            onClick()
          }}
          aria-label={title}
        >
          <div className="flex h-[68px] flex-row items-center justify-start">
            {icon && (
              <Icon24
                className="mr-2"
                src={icon}
                color={iconColor ?? "bg-rl-gray-900"}
                ariaLabel={""}
              />
            )}
            <span className="text-rl-gray-700 font-rl-body1 font-normal">
              {title}
            </span>
          </div>
        </button>
      </li>
    </>
  )
}

export default BottomSheetMenuItem
